import { render } from "./SharePostModal.vue?vue&type=template&id=8382da14&scoped=true"
import script from "./SharePostModal.vue?vue&type=script&lang=js"
export * from "./SharePostModal.vue?vue&type=script&lang=js"

import "./SharePostModal.vue?vue&type=style&index=0&id=8382da14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8382da14"]])

export default __exports__